var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95023 13.0087L0.293226 7.35168C0.105755 7.16415 0.000440598 6.90984 0.000440598 6.64468C0.000440598 6.37951 0.105755 6.1252 0.293226 5.93768L5.95023 0.280676C6.13883 0.0985174 6.39143 -0.00227642 6.65363 1.90735e-06C6.91582 0.00228024 7.16664 0.10745 7.35205 0.292858C7.53745 0.478266 7.64262 0.729079 7.6449 0.991276C7.64718 1.25347 7.54638 1.50607 7.36423 1.69468L3.41423 5.64468L16.6572 5.64468C16.9224 5.64468 17.1768 5.75003 17.3643 5.93757C17.5519 6.12511 17.6572 6.37946 17.6572 6.64468C17.6572 6.90989 17.5519 7.16425 17.3643 7.35178C17.1768 7.53932 16.9224 7.64468 16.6572 7.64468L3.41423 7.64468L7.36423 11.5947C7.45974 11.6869 7.53592 11.7973 7.58833 11.9193C7.64074 12.0413 7.66832 12.1725 7.66948 12.3053C7.67063 12.4381 7.64533 12.5697 7.59505 12.6926C7.54477 12.8155 7.47051 12.9272 7.37662 13.0211C7.28273 13.115 7.17108 13.1892 7.04818 13.2395C6.92528 13.2898 6.7936 13.3151 6.66083 13.3139C6.52805 13.3128 6.39683 13.2852 6.27482 13.2328C6.15282 13.1804 6.04247 13.1042 5.95023 13.0087Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.f34e3304158df4461c1ba2dab6cd32fd.svg";
export { ForwardRef as ReactComponent };